import apiUrl from '../../../constants'
import user_tracker from '../../../usertracker'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import jsPDF from 'jspdf';
import Printd from 'printd'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'


export default {
  name: 'center-scan-in-trip',
  components: {
    BasicSelect,
    VueElementLoading,
    Multiselect
  },
  props: [],
  data() {
    return {
      pageCount: 0,
      pageNo: 0,
      routetype: '',
      bagcondition: "Intact",
      retrivedate: '',
      retrivetime: '',
      bagsealno: '',
      offloadReason: '',
      hubid: '',
      hubName: '',
      vehicletype: '',
      vehiclesealno: '',
      isLoading: false,
      createdby: '',
      offloadreason: '',
      OffloadStatusCode: '',
      offloadReasonArray: [],
      InvalidSealReasonArray: [],
      VehicleListArray: [],
      ConnectionNameData: [],
      BagShortageData: [],
      BagDetails: [],
      connectionLoading: '',
      connectiontype: '',
      connectionfltlist: [],
      connectionfltitem: {
        value: '',
        text: '',
        destinationhubid: ''
      },
      vehicletypelist: [],
      opened: [],
      vehicletypeitem: {
        value: '',
        text: '',
        vehicleno: '',
        tripid: '',
        isdestination: ''
      },
      // for network-local
      networklocalvehicleitem: {
        value: '',
        text: '',
        vehicleno: '',
        tripid: '',
        isdestination: ''
      },
      vehicleclosekmErr: '',
      networklocalclosekm: '',
      isDestination: false,
      networklocalsealcondition: '',
      networklocalsealconditionErr: '',
      sealcondition: '',
      sealconditionErr: '',
      vehiclesealno: '',
      vehiclesealnoErr: '',
      networklocaldeparturesealno: '',
      networklocaldeparturesealnoErr: '',
      ScheduleID: '',
      ShortageBagRecord: [],
      disableclosevehiclebtn: true,
      isShoratge: false,
      AllowDepartureSeal: false,
      allowShoratge: true,
      disableFieldforDeparture: false,
      IsSavedDepartureSeal: false,
      reasonlist: [],
      reasonitem: {
        value: '',
        text: ''
      },
      offloadreasonlist: [],
      offloadreasonitem: {
        value: '',
        text: ''
      },
      reason: '',
      connectionname: '',
      bagno: '',
      tripid: '',
      tripsheetno: '',
      invoiceno: '',
      vehicleno: '',
      isConnectionError: 0,
      ConnectionError: '',
      IsVehicleSealNoError: 0,
      VehicleSealNoError: '',
      Isreasonerror: '',
      reasonError: '',
      invalidsealreason: '',
      modaldata: '',
      updatedVehicleSealNo: '',
      disableBtn: 0,
      IsBagConfirm: false,
      OffloadReasontype: false,
      IsNddBagConfirm: false,
      InscanVehicle: false,
      InvalidReason: false,
      modalShow: false,
      updatemodal: false,
      IsOverageShipmentBagTable: true,
      IsBagDetailsTable: false,
      BagData: [],
      vehiclelist: [],
      vehicleitem: {
        value: '',
        text: ''
      },
      localvehicle: '',
      vehicletypeErr: '',
      vehiclesealnoErr: '',
      vehiclesealconditionErr: '',
      currentkm: '',
      IsLocalVehiclesVisible: false,
      ModalStatus: '',
      PDDBagModal: false,
      IsRSC: '',
      vehicletripid: '',
      vehicleNumber: '',
      totalRecords: 0,
      showPendingList: false,
      PendingPaperBagsCount: '',
      parentBagDetails: [],
      childBagDetails: [],
      viewdata: [],
      paperbagno: '',
      PaperBagNoError: '',
      IsPaperWorkBag: false,
      exceptionreason: '',
      ExceptionError: '',
      isexceptional: false,
      missingType: false,
      generatedPaperBagDetails: [],
      IsPaperWorkPending: false,
      paperWorkComplete: false,
      disablescanInBtn: true,
      disablePaperWorkBtn: true,
      disableField: false,
      pendingCount: '',
      PendingInscanBagData: [],
      CargoParentMPSDetails: [],
      CargoParentMPSDataModel: false,
      CSMID: '',
      bagstatus: '',
      listtype: 'Ecom',
      IsPendingInscanList: false,
      IsPendingInscanBtn: false,
      InScannedBagsCount: 0,
      PendingBagsCount: 0,
      ShortageBagsCount: 0,
      parentAWB: '',
      ParentAWBError: '',
      IsParentAWB: false,
      isExistBag: false,
      //for missing paper bag
      IsMissingPaperBag: false,
      missingType: false,
      missingpaperbag: '',
      MissingPaperBagError: '',
      missingreason: '',
      MissingReasonError: '',
      missroutemsg: '',
      missingpaperbaglist: [],
      missingpaperbagitem: {
        text: ''
      },

      //for prealert data
      IsPrealertData: true,
      PrealertTripData: [],
      PrealertBagData: [],
      PrealertBagShortageList: [],
      totalshipment: 0,
      totalphysicalwt: 0,
      totalvolumetricwt: 0,
      Prealertmodal: false,
      selectedRow: '',
      selectedRowError: '',
      PrealertPrintmodal: false,
      PrintData: '',
      prealertConnection: '',
      prealertVehicle: '',
      prealertInvoiceDate: '',
      prealertInvoiceTime: '',
      IsHeavyShipment: false,
      mpstype:'',
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: '',
      Loading: false,
      IsUnloadingSheet: false,
      UnloadingSheetModel: false,
      unloadingtripsheetno: '',
      UnloadingTripData: [],
      UnloadingBagData: [],
      isLoadingSheetModal: false,
      IsSheet: false,
      printDate: "",
      printBy: "",
      selectedbags: [],
      TripSheetNoError: '',
      timeoutHandler: 0,
      inputString: '',
      inputString1:'',
      manualInput: false,
      manualInscan:false,
      //for close vehicle
      closeVehicleModal: false,
      IsAllowToCloseVehicle: false,
      CloseVehicleMsg: '',
      userData:[],
      connectionName:'',
      disabled: false,
      WithoutSealcon : false,
      sealtype:"",
      networklocalsealstatus:"WithSeal",
      reasonIerr:"",
      ConfirmBagShortage: false,
			isLoadingSearch:false,
      ShortageBagNo : '',
      scanInRes: {}
    }
  },
  computed: {},

  created: function() {
  this.$validator.extend('checkprefix', {
    getMessage: field => `Vehicle Seal Number Must Start With ${this.vehiclesealdata.sealprefix.join(" or ")}`,
    validate: value => {
      if(value && this.vehiclesealdata && this.vehiclesealdata.sealprefix){
          let result = false
          for (let i = 0; i < this.vehiclesealdata.sealprefix.length; i++) {
            if (value.toLowerCase().startsWith(this.vehiclesealdata.sealprefix[i].toLowerCase())) {
                result = true;
                break;
            }
          }
          return result;
       }else{
         return true;
       }
    }
 });
},

  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '-'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    momentPrealert: function(date) {
      if (date == null || date == '')
        return '-'
      return moment(date).format('DD-MM-YYYY');
    },
    toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
    },
  },
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.hubid = userdetail[0].HubId[0];
    this.createdby = userdetail[0].email
    this.printDate = moment().format('DD-MM-YYYY');
    this.printBy = userdetail[0].email;
    this.getHubName(this.hubid);
    this.getVehicleList();
    
    //for prealert data
    this.getPrealertTripData();
    // user_tracker.checkUserIP(userdetail[0], "CenterScanInTrip", this.$route.path);
  },
  methods: {
    checkBarcode(e) {
      if (this.timeoutHandler) {
        clearTimeout(this.timeoutHandler)
        this.inputString += String.fromCharCode(e.keyCode)
      }
      this.timeoutHandler = setTimeout(() => {
        if (this.inputString.length <= 3) {
          this.manualInput = true
          this.inputString = ''
        } else {
          this.manualInput = false
          this.inputString = ''
        }
      }, 10)
    },
    checkBarcodeForPaperBagOrParentAWB(e){
			if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler)
      this.inputString1 += String.fromCharCode(e.keyCode)
    	}
			this.timeoutHandler = setTimeout(() => {
		 		if (this.inputString1.length <= 3) {
			 		this.manualInscan = true
			 		this.inputString1 = ''
		 		}else{
			 		this.manualInscan = false
			 		this.inputString1 = ''
		 		}
	 		}, 10)
 		},
    openOffLoadMaster() {
      let path = this.$router.resolve("/OffloadShipment/")
      window.open(path.href, '_blank');
    },
    getHubName(hubid) {
      this.input = {
        hubids: [hubid]
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubName = result.data.ResponseData[0].HubName;
            this.IsRSC = result.data.ResponseData[0].IsRSC;
          } else {
            this.hubName = '';
          }
        }, error => {
          console.error(error);
        })
    },
    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    getOffLoadReasons() {
      var self = this
      this.input = ({})
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "getOffloadReasons?OffloadReasonType=HubInScanOffload",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.offloadReasonArray = result.data.ResponseData
            for (var i = 0; i < this.offloadReasonArray.length; i++) {
              this.offloadreasonlist.push({
                value: this.offloadReasonArray[i].offloadstatuscode,
                text: this.offloadReasonArray[i].offloadreason
              })
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    selectOffloadReason(offloadreasonitem) {
      this.offloadreasonitem = offloadreasonitem
      this.OffloadStatusCode = this.offloadreasonitem.value
      this.offloadreason = this.offloadreasonitem.text
    },
    getVehicleList() {
      this.VehicleListArray = []
      this.vehicletypelist = []
      var self = this
      this.input = ({})
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getAllScanVehicleList?currentHubId=' + self.hubid,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.VehicleListArray = result.data.ResponseData
            for (var i = 0; i < this.VehicleListArray.length; i++) {
              this.vehicletypelist.push({
                value: this.VehicleListArray[i].connectionschedulemasterid,
                vehicleno: this.VehicleListArray[i].vehicleno,
                text: this.VehicleListArray[i].vehicleno + '(' + this.VehicleListArray[i].tripid + ')',
                tripid: this.VehicleListArray[i].tripid,
                isdestination: this.VehicleListArray[i].isdestination,
                connectionName:this.VehicleListArray[i].connectionname,
                connectiontype : this.VehicleListArray[i].connectiontype
              })
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    selectVehicleType(vehicletypeitem) {
      this.networklocalsealstatus = "WithSeal"
      this.WithoutSealcon = false
      this.reason = ''
      this.InvalidReason = false
      this.invalidsealreason = ''
      this.vehicletypeitem = vehicletypeitem
      this.vehicletype = this.vehicletypeitem.vehicleno
      this.isDestination = this.vehicletypeitem.isdestination
      this.vehicletripid = this.vehicletypeitem.tripid
      this.vehicleNumber = this.vehicletypeitem.vehicleno
      this.ScheduleID = this.vehicletypeitem.value
      this.connectionName = this.vehicletypeitem.connectionName
      this.disabled = true
      this.disablescanInBtn = true
      this.connectiontype = this.vehicletypeitem.connectiontype
      if (this.connectiontype == 4) {
        this.routetype = 'network-local'
        this.getvehiclesealdata(this.connectiontype)
      }else if (this.connectiontype == 0) {
        this.routetype = 'network';
        this.selectNetworklocalVehicle(vehicletypeitem);
        this.getvehiclesealdata(this.connectiontype)
      }else if (this.connectiontype == 1) {
        this.routetype = 'local'
        this.disablescanInBtn = false
      }else if (this.connectiontype == 3) {
        this.routetype = 'linehaul'
        this.disablescanInBtn = false
      }else if (this.connectiontype == 5) {
        this.routetype = 'BrooksNBonds'
        this.disablescanInBtn = false
      }
      if (this.vehicletype == '') {
        this.vehicletypeErr = 'The Vehicle No/ Trip ID field is required.'
      } else {
        this.vehicletypeErr = ''
      }
      if (this.vehicletype != '' && this.vehiclesealno != '') {
        this.disableclosevehiclebtn = false
      } else {
        this.disableclosevehiclebtn = true
      }
    },
    //for network-local
    selectNetworklocalVehicle(networklocalvehicleitem) {
      this.networklocalvehicleitem = networklocalvehicleitem
    },
    clearCloseKMError() {
      var decimal = /^([0-9]*[1-9][0-9]*(\.[0-9]+)?|[0]+\.[0-9]*[1-9][0-9]*)$/
      if (this.networklocalclosekm == '') {
        this.vehicleclosekmErr = 'The Close KM field is required.'
      } else if (decimal.test(this.networklocalclosekm) == false) {
        this.vehicleclosekmErr = 'Enter Valid Close KM'
      } else {
        this.vehicleclosekmErr = ''
      }
    },
    checkSealCondition() {
      this.reason = ''
      this.reasonIerr = ''
      this.WithoutSealcon = false
      this.InvalidReason = false
      this.invalidsealreason = ''
      this.vehiclesealnoErr = ''
      this.vehiclesealno = ''
      if (this.networklocalsealstatus == "WithoutSeal") {
        this.WithoutSealcon = true
      }
    },
    removeError() {
      if (this.networklocalsealstatus == '') {
        this.vehiclesealconditionErr = 'The Vehicle Seal Condition field is required.'
        return false;
      } else {
        this.vehiclesealconditionErr = ''
        if (this.vehiclesealno == '') {
          this.vehiclesealnoErr = 'The Vehicle Seal No field is required.'
        } else {
          this.vehiclesealnoErr = ''
        }
      }
      if (this.vehicletype != '' && this.vehiclesealno != '') {
        this.disableclosevehiclebtn = false
      } else {
        this.disableclosevehiclebtn = true
      }
    },
    // InScanVehicle() {
    InScanVehicle() {
      this.reasonIerr = ''
      this.vehicletypeErr = ''
      this.vehicleclosekmErr = ''
      this.vehiclesealconditionErr = ''
      this.vehiclesealnoErr = ''
      // for network-local
      var decimal = /^([0-9]*[1-9][0-9]*(\.[0-9]+)?|[0]+\.[0-9]*[1-9][0-9]*)$/
      if ((this.vehicletype == '') || (this.isDestination == true && this.networklocalclosekm == '') ||
      (this.isDestination == true && decimal.test(this.networklocalclosekm) == false) || (this.networklocalsealstatus=='WithoutSeal' && this.reason=='') ||
      (this.vehiclesealno == '' && this.reason == '')) {
        this.vehicletypeErr = (this.vehicletype == '') ? 'The Vehicle No/ Trip ID field is required.' : '';
        this.vehicleclosekmErr = (this.isDestination == true && this.networklocalclosekm == '') ? 'The Close KM field is required.' :
        (this.isDestination == true && decimal.test(this.networklocalclosekm) == false) ? 'Enter Valid Close KM' : '';
        this.reasonIerr = (this.networklocalsealstatus=='WithoutSeal' && this.reason=='') ? 'The Reason field is required' : '';
        this.vehiclesealnoErr = (this.networklocalsealstatus!='WithoutSeal' && !this.vehiclesealno) ? 'The Vehicle Seal No field is required.' : '';
        return false;
      }
      this.input = ({
        "HubID": this.hubid,
        "ConnectionScheduleMasterID": this.ScheduleID,
        "Reason": this.InvalidReason == true ? this.invalidsealreason : this.reason ? this.reason :'',
        "LastModifiedBy": this.createdby,
        "VehicleSealCondition": this.networklocalsealstatus,
        "VehicleSealNo": this.vehiclesealno
      });

      if (this.isDestination == true) {
        this.input.CurrentKM = this.networklocalclosekm
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'inscanVehicle_v1',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.disablescanInBtn = false
          if (result.data.ResultCode == 100) {
            if ((this.routetype == "network" || this.routetype == "network-local") && this.vehicletypeitem.isdestination == false) {
              this.AllowDepartureSeal = true
              this.disableFieldforDeparture = true
            }

            this.IsPendingInscanBtn = true
            this.invalidTokenModal = false
            this.tripid = result.data.ResponseData.tripid
            this.tripsheetno = result.data.ResponseData.thcno
            this.invoiceno = result.data.ResponseData.invoiceno
            this.vehicleno = result.data.ResponseData.vehicleno
            this.CSMID = result.data.ResponseData.connectionschedulemasterid
            this.allowShoratge = false
            // this.disableBtn = 1
            this.getPendingInscanBagCount();
            this.$alertify.success(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 109) {
            this.AllowDepartureSeal = false
            //this.disableBtn = 0
            this.invalidTokenModal = false
            this.InvalidReason = true
            this.allowShoratge = true
            if (this.routetype!='local' && this.routetype!='linehaul') {
              this.disablescanInBtn = true
            }
            this.getInvalidSealReason();
            this.$alertify.error(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 102) {
            if ((this.routetype == "network" || this.routetype == "network-local") && this.vehicletypeitem.isdestination == false) {
              this.AllowDepartureSeal = true
              this.disableFieldforDeparture = true
            }

            this.IsPendingInscanBtn = true
            this.invalidTokenModal = false
            this.tripid = result.data.ResponseData.tripid
            this.tripsheetno = result.data.ResponseData.thcno
            this.invoiceno = result.data.ResponseData.invoiceno
            this.vehicleno = result.data.ResponseData.vehicleno
            this.CSMID = result.data.ResponseData.connectionschedulemasterid
            this.allowShoratge = false
            this.getPendingInscanBagCount();
            this.$alertify.error(result.data.ReturnMessage)
            //this.disableBtn = 1
          } else if (result.data.ResultCode == 401) {
            this.AllowDepartureSeal = false
            this.invalidTokenModal = true
            this.allowShoratge = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.AllowDepartureSeal = false
            this.invalidTokenModal = false
            this.allowShoratge = true
            //this.disableBtn = 0
            this.InvalidReason = false
            this.IsPendingInscanBtn = false
            if (this.routetype!='local' && this.routetype!='linehaul') {
              this.disablescanInBtn = true
            }
            this.$alertify.error(result.data.ReturnMessage)
          }
          //for paper work
          this.IsPaperWorkPending = result.data.IsPaperWorkPending
          if (this.IsPaperWorkPending == true) {
            this.disablescanInBtn = true
            this.disablePaperWorkBtn = false
            this.disableField = true
            this.bagcondition = "Intact"
            this.bagsealno = ''
            this.manualInput = false
            this.offloadreason = ''
            this.offloadreasonitem = {
              value: '',
              text: ''
            }
          } else {
            this.disablePaperWorkBtn = true
            this.disableField = false
          }
        }, error => {
          console.error(error)
        })
    },
    getInvalidSealReason() {
      this.input = ({})
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "getInvalidSealReasons",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.InvalidSealReasonArray = result.data.ResponseData
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    openUpdateModal() {
      this.updatemodal = true
    },
    closeUpdateModal() {
      this.updatemodal = false
      this.updatedVehicleSealNo = ''
    },
    clearError() {
      if (this.updatedVehicleSealNo == '') {
        this.IsVehicleSealNoError = 1,
          this.VehicleSealNoError = 'The Vehicle Seal No field is required.'
      } else {
        this.IsVehicleSealNoError = 0,
          this.VehicleSealNoError = ''
      }
    },
    clearDepartureSealNoError() {
      if (this.networklocaldeparturesealno == '') {
        this.networklocaldeparturesealnoErr = 'The Vehicle Departure Seal No field is required.'
      } else {
        this.networklocaldeparturesealnoErr = ''
      }
    },
    UpdateVehicle(type) {
      if (type == "networklocal" && this.networklocaldeparturesealno == '') {
        this.networklocaldeparturesealnoErr = 'The Vehicle Departure Seal No field is required.'
        return false;
      } else {
        this.networklocaldeparturesealnoErr = ''
      }


      if (type != "networklocal" && this.updatedVehicleSealNo == '') {
        this.IsVehicleSealNoError = 1,
          this.VehicleSealNoError = 'The Vehicle Seal No field is required.'
        return false;
      } else {
        this.IsVehicleSealNoError = 0,
          this.VehicleSealNoError = ''
      }
      if (this.routetype == "network-local") {
        this.input = ({
          "ConnectionScheduleMasterID": this.ScheduleID,
          "TripID": Number(this.tripid),
          "CurrentHubId": this.hubid,
          "VehicleSealNo": this.networklocaldeparturesealno,
          "LastModifiedBy": this.createdby
        })
      } else {
        this.input = ({
          "ConnectionScheduleMasterID": this.ScheduleID,
          "TripID": Number(this.tripid),
          "CurrentHubId": this.hubid,
          "VehicleSealNo": this.updatedVehicleSealNo,
          "LastModifiedBy": this.createdby
        })
      }
      if (type == 'networklocal') {
        this.input.VehicleSealNo = this.networklocaldeparturesealno
      } else {
        this.input.VehicleSealNo = this.updatedVehicleSealNo
      }
      /*nxb and xb changes*/
     if(this.updatedVehicleSealNo != ''){
     let sealno = this.validatebuttons()
       if(!sealno){
         this.$alertify.error('Vehicle Seal Number Must Start With '+ this.vehiclesealdata.sealprefix.join(" or "));
         return false
       }
     }
   if(this.networklocaldeparturesealno != ''){
     let sealno = this.validateforDepartureSealNo()
       if(!sealno){
         this.$alertify.error('Vehicle Seal Number Must Start With '+ this.vehiclesealdata.sealprefix.join(" or "));
         return false
       }
   }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'updateVehicleSeal',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.disableBtn = 1
            /*nxb and xb changes*/
            let connType = (this.routetype == "network-local") ? 4 : (this.routetype =='network') ? 0 : null
            this.getvehiclesealdata(connType)
            if (type != 'networklocal') {
              this.networklocaldeparturesealno = this.updatedVehicleSealNo
            }
            this.invalidTokenModal = false
            this.updatemodal = false
            //this.networklocaldeparturesealno = ''
            this.updatedVehicleSealNo = ''
            this.$validator.reset();
            this.IsSavedDepartureSeal = true
            this.$alertify.success(result.data.ReturnMessage)
            if (type == "networklocal") {
              this.disableFieldforDeparture = false
              this.IsSavedDepartureSeal = true
            }
          } else if (result.data.ResultCode == 401) {
            this.disableBtn = 0
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
            this.IsSavedDepartureSeal = false
          } else {
            this.invalidTokenModal = false
            if (type == "networklocal") {
              this.disableBtn = 0
              this.IsSavedDepartureSeal = false
            } else {
              this.disableBtn = 1
              this.IsSavedDepartureSeal = true
            }
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },

    /*nxb and xb changes*/
   getvehiclesealdata(connectiontype){
     this.vehiclesealdata = {}
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getVehicleSealConfiguration',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
           this.vehiclesealdata  =  result.data.ResponseData.find(x => x.connectionType == this.connectiontype)
          }
        })
     },

    ScanIn() {
      if (this.routetype == '' || this.sealtype == '' || this.bagcondition == '' || this.bagsealno == '') {
        this.manualInput = false
        return false
      }else if(this.connectiontype != 1 && this.connectiontype != 3 && this.connectiontype != 5) {
        if(this.networklocalsealstatus!='WithoutSeal' && this.vehiclesealno=='') {
          return false
        }else if(this.networklocalsealstatus=='WithoutSeal' && this.reason=='') {
          return false
        }
      }
        this.Loading = true
        this.isLoading = true;
        this.scanInRes = {};
        this.input = ({
          "BagReceiveCondition": this.bagcondition,
          "Routetype": this.routetype,
          "SealType": this.sealtype,
          "SealNo": this.bagsealno.trim(),
          "currentHubId": this.hubid,
          "currentHubName": this.hubName,
          "bagNumber": this.bagsealno,
          "LastModifiedBy": this.createdby,
          "IsRSC": this.IsRSC,
          "statusMarkedFrom": "web",
          "IsNddBagConfirm": this.IsBagConfirm == true ? this.IsNddBagConfirm : false,
          "TripID": this.vehicletripid,
          "VehicleNo": this.vehicleNumber,
          "CurrentKM": this.currentkm,
          "ProcessNonPDDBag": false,
          "isManualEntry": this.manualInput
        })
        if (this.OffloadReasontype == true) {
          this.input.OffloadStatusCode = this.OffloadStatusCode,
            this.input.OffloadReason = this.offloadreason
        }
        // if (this.routetype == 'network-local' && this.isDestination == true) {
        //   this.input.CurrentKM = this.networklocalclosekm
        // }
        if (this.isDestination == true) {
          this.input.CurrentKM = this.networklocalclosekm
        }
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'scanIn',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            this.Loading = false
            this.isLoading = false;
            this.OffloadReasontype = false
            this.scanInRes = result.data;
            if (result.data.ResultCode == 100) {
              this.IsHeavyShipment = result.data.isHeavyShipment
              this.mpstype = result.data.mpstype
              this.invalidTokenModal = false
              this.$toast.success(result.data.ReturnMessage, {
                timeout: 10000,
                position: 'bottom-right',
              });
              //this.$alertify.success(result.data.ReturnMessage)
              this.bagsealno = ''
              this.manualInput = false
              this.$validator.reset()
              if (this.ScheduleID != '') {
                this.getPendingInscanBagCount();
              }
              //this.resetForm()
            } else if (result.data.ResultCode == 107) {
              this.IsHeavyShipment = false
              this.mpstype = ''
              this.invalidTokenModal = false
              this.$alertify.error("Please select Offload Reason")
              this.OffloadReasontype = true
              this.getOffLoadReasons()
            } else if (result.data.ResultCode == 108) {
              this.IsHeavyShipment = false
              this.mpstype = ''
              this.invalidTokenModal = false
              this.IsBagConfirm = true
              this.IsNddBagConfirm = true
            } else if (result.data.ResultCode == 105) {
              this.IsHeavyShipment = false
              this.mpstype = ''
              this.invalidTokenModal = false
              this.PDDBagModal = true
              this.ModalStatus = result.data.ReturnMessage
            } else if (result.data.ResultCode == 109) {
              this.IsHeavyShipment = false
              this.mpstype = ''
              this.invalidTokenModal = false
              this.disablePaperWorkBtn = false
              this.$alertify.error(result.data.ReturnMessage)
            } else if (result.data.ResultCode == 401) {
              this.IsHeavyShipment = false
              this.mpstype = ''
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.IsHeavyShipment = false
              this.mpstype = ''
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
            user_tracker.checkUserIP(this.userData[0], "CenterScanInTrip_BagInScan", this.$route.path,this.input);
          }, error => {
            this.Loading = false
            console.error(error)
          })
    },
    processPDDBag() {
      this.Loading = true
      this.isLoading = true;
      this.scanInRes = {};
      this.input = ({
        "BagReceiveCondition": this.bagcondition,
        "Routetype": this.routetype,
        "SealType": this.sealtype,
        "SealNo": this.bagsealno.trim(),
        "currentHubId": this.hubid,
        "currentHubName": this.hubName,
        "bagNumber": this.bagsealno,
        "LastModifiedBy": this.createdby,
        "IsRSC": this.IsRSC,
        "statusMarkedFrom": "web",
        "IsNddBagConfirm": this.IsBagConfirm == true ? this.IsNddBagConfirm : false,
        "TripID": this.vehicletripid,
        "VehicleNo": this.vehicleNumber,
        "CurrentKM": this.currentkm,
        "ProcessNonPDDBag": true,
        "isManualEntry": this.manualInput
      })
      if (this.OffloadReasontype == true) {
        this.input.OffloadStatusCode = this.OffloadStatusCode,
          this.input.OffloadReason = this.offloadreason
      }
      if (this.isDestination == true) {
        this.input.CurrentKM = this.networklocalclosekm
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'scanIn',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.Loading = false
          this.isLoading = false;
          this.OffloadReasontype = false
          this.scanInRes = result.data;
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.IsHeavyShipment = result.data.isHeavyShipment
            this.mpstype = result.data.mpstype
            this.$alertify.success(result.data.ReturnMessage)
            this.bagsealno = ''
            this.manualInput = false
            this.$validator.reset()
            //this.resetForm()
          } else if (result.data.ResultCode == 107) {
            this.invalidTokenModal = false
            this.IsHeavyShipment = false
            this.mpstype = ''
            this.$alertify.error("Please select Offload Reason")
            this.OffloadReasontype = true
            this.getOffLoadReasons()
          } else if (result.data.ResultCode == 108) {
            this.invalidTokenModal = false
            this.IsHeavyShipment = false
            this.mpstype = ''
            this.IsBagConfirm = true
            this.IsNddBagConfirm = true
          } else if (result.data.ResultCode == 105) {
            this.invalidTokenModal = false
            this.IsHeavyShipment = false
            this.mpstype = ''
            this.PDDBagModal = true
            this.ModalStatus = result.data.ReturnMessage
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.IsHeavyShipment = false
            this.mpstype = ''
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.IsHeavyShipment = false
            this.mpstype = ''
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.Loading = false
          console.error(error)
        })
    },
    closePDDBagModal() {
      this.PDDBagModal = false
    },
    clearRoutetypeError() {
      this.sealtype = ''
      if (this.routetype == "linehaul") {
        this.sealtype = 'WithoutSeal'
      }

      this.bagcondition = "Intact"
      this.bagsealno = ''
      this.manualInput = false
      this.offloadReason = ''
      this.vehicletype = ''
      this.vehiclesealno = ''
      this.invalidsealreason = ''
      this.vehicletypeErr = ''
      this.vehiclesealnoErr = ''
      this.vehiclesealconditionErr = ''
      this.vehiclelist = []
      this.vehicletypelist = []
      // this.vehicletypelist = []
      this.vehicletypeitem = {
        value: '',
        text: '',
        vehicleno: '',
        tripid: '',
        isdestination: ''
      }
      //for network-local
      this.allowShoratge = true
      this.disableFieldforDeparture = false
      // this.vehicletypelist = []
      this.networklocalvehicleitem = {
        value: '',
        text: '',
        vehicleno: '',
        tripid: '',
        isdestination: ''
      }
      this.vehicleclosekmErr = ''
      this.isDestination = false
      this.networklocalsealcondition = ''
      this.networklocalsealconditionErr = ''
      this.sealtype = ''
      this.vehiclesealno = ''
      this.vehiclesealnoErr = ''
      this.networklocaldeparturesealno = ''
      this.networklocaldeparturesealnoErr = ''
      this.vehicleitem = {
        value: '',
        text: ''
      }
      this.localvehicle = ''
      this.currentkm = ''
      this.OffloadReasontype = false
      this.IsNddBagConfirm = false
      this.InscanVehicle = false
      this.InvalidReason = false
      this.IsLocalVehiclesVisible = false
      this.disableBtn = 0
      this.disableclosevehiclebtn = true
      this.AllowDepartureSeal = false
      this.updatedVehicleSealNo = ''
      this.IsSavedDepartureSeal = false
      this.tripid = ''
      this.tripsheetno = ''
      this.invoiceno = ''
      this.vehicleno = ''
      this.CSMID = ''
      this.vehicletripid = ''
      this.vehicleNumber = ''
      this.ScheduleID = ''
      this.IsHeavyShipment = false
      this.mpstype = ''
      /*nxb and xb changes*/
      this.vehiclesealdata={
        connectiontype:'',
        connectionname:'',
        sealprefix:[]
      }
      // this.getVehicleList()
      this.$validator.reset();
    },
    resetForm() {
      this.routetype = ''
      this.connectionName = ''
      this.sealtype = ''
      this.bagcondition = "Intact"
      this.bagsealno = ''
      this.manualInput = false
      this.offloadReason = ''
      this.vehicletype = ''
      this.vehiclesealno = ''
      this.invalidsealreason = ''
      this.vehicletypeitem = {
        value: '',
        text: '',
        vehicleno: '',
        tripid: '',
        isdestination: ''
      }
      this.offloadreasonitem = {
        value: '',
        text: ''
      }
      this.vehicleitem = {
        value: '',
        text: ''
      }
      this.localvehicle = ''
      this.vehicletypeErr = ''
      this.vehiclesealnoErr = ''
      this.disableBtn = 0
      this.currentkm = ''
      this.vehicleNumber = ''
      this.OffloadReasontype = false
      this.IsNddBagConfirm = false
      this.InscanVehicle = false
      this.InvalidReason = false
      //for paper work
      this.IsPaperWorkPending = false
      this.paperWorkComplete = false
      this.disablescanInBtn = false
      this.disablePaperWorkBtn = true
      this.disableField = false
      this.IsPendingInscanBtn = false
      this.IsPendingInscanList = false
      this.IsLocalVehiclesVisible = false
      // for network-local
      this.allowShoratge = true
      this.disableFieldforDeparture = false
      this.networklocalvehicleitem = {
        value: '',
        text: '',
        vehicleno: '',
        tripid: '',
        isdestination: ''
      }
      this.vehicleclosekmErr = ''
      this.networklocalclosekm = ''
      this.isDestination = false,
      this.networklocalsealcondition = ''
      this.networklocalsealconditionErr = ''
      this.vehiclesealno = ''
      this.vehiclesealnoErr = ''
      this.networklocaldeparturesealno = ''
      this.updatedVehicleSealNo = ''
      this.IsSavedDepartureSeal = false
      this.networklocaldeparturesealnoErr = ''
      this.ShortageBagRecord = []
      this.PendingInscanBagData = []
      this.disableclosevehiclebtn = true
      this.AllowDepartureSeal = false
      this.isShoratge = false
      this.listtype = 'Ecom'
      this.missingpaperbag = ''
      this.missingpaperbagitem = {
        text: ''
      }
      this.MissingPaperBagError = ''
      this.missingreason = ''
      this.MissingReasonError = ''
      this.IsMissingPaperBag = false
      this.missingType = false
      this.missroutemsg = ''
      this.IsHeavyShipment = false
      this.mpstype = ''
      this.tripid = ''
      this.tripsheetno = ''
      this.invoiceno = ''
      this.vehicleno = ''
      this.CSMID = ''
      this.vehicletripid = ''
      this.vehicleNumber = ''
      this.ScheduleID = ''
      this.CloseVehicleMsg = ''
      this.closeVehicleModal = false
      this.IsAllowToCloseVehicle = false
      this.WithoutSealcon = false
      this.reason = ''
      this.networklocalsealstatus = 'WithSeal'
      this.disablescanInBtn = true
      /*nxb and xb changes*/
      this.vehiclesealdata={
        connectiontype:'',
        connectionname:'',
        sealprefix:[]
      }
      this.$validator.reset();
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        this.vehicletypeErr = ''
        this.vehiclesealnoErr = ''
        this.vehiclesealconditionErr = ''
        this.vehicleclosekmErr = ''
        if (!result) {
          return false;
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    //For Mark Bag Shortage
    //get connection name
    searchConnection(connectionfltitem) {
      this.connectionfltitem = connectionfltitem
      this.connectionname = this.connectionfltitem.text
    },
    //to get connection name list
    getConnectionName() {
      this.connectionLoading = 'Loading Connection...'
      var i = 0;
      this.ConnectionNameData = []
      this.connectionfltlist = []
      this.connectionname = ''
      this.connectionfltitem = {
        value: '',
        text: '',
        destinationhubid: ''
      }
      this.$validator.reset()
      this.input = ({
        "destinationHubID": this.hubid,
        "isLocalConnections": this.connectiontype
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'getConnectionsList',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.connectionLoading = ''
          this.ConnectionNameData = result.data.ResponseData
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.isConnectionError = 0;
            this.ConnectionError = ''
            for (i = 0; i < this.ConnectionNameData.length; i++) {
              this.connectionfltlist.push({
                value: this.ConnectionNameData[i].ConnectionID,
                text: this.ConnectionNameData[i].ConnectionName,
                destinationhubid: this.ConnectionNameData[i].destinationHubID
              })
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.isConnectionError = 1;
            this.ConnectionError = 'No Connection Found'
          }
        }, error => {
          this.$alertify.error('error in connection api')
          console.error(error)

        })
    },
    //called on search button
    getBagShortageData() {
      this.IsBagDetailsTable = false
      this.IsOverageShipmentBagTable = true
      this.ConnectionNameData = []
      this.BagShortageData = []
      this.BagDetails = []
      this.opened = []
      if (this.connectionfltitem.destinationhubid != "" && this.connectionfltitem.value != "") {
        this.input = ({
          "destinationHubID": Number(this.connectionfltitem.destinationhubid),
          "connectionID": this.connectionfltitem.value
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'getBagCountByConnection',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.BagShortageData = result.data.ResponseData
              if (this.bagno != '') {
                this.getBagDetails(this.BagShortageData[0], 0)
              }
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      }
    },
    //called on No of Bags
    getBagDetails(data, ind) {
      this.BagDetails = []
      const index = this.opened.indexOf(ind);
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened = [];
        this.opened.push(ind)
        this.input = ({
          "destinationHubID": Number(data.HubID),
          "connectionID": Number(data.connectionid)
        })
        if (this.bagno != '') {
          this.input.bagNumber = this.bagno
        }
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'getBagDetailsByConnection',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.BagDetails = result.data.ResponseData
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              //this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      }
    },
    closeBagDetailsList() {
      this.opened = [];
    },
    //called on No of Bags
    showBagData() {
      if (this.bagno != '') {
        this.IsBagDetailsTable = true
        this.IsOverageShipmentBagTable = false
        this.BagData = []
        this.input = ({
          "destinationHubID": Number(this.connectionfltitem.destinationhubid),
          "connectionID": Number(this.connectionfltitem.value),
          "bagNumber": this.bagno
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'getBagDetailsByConnection',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.BagData = result.data.ResponseData
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      } else {
        this.IsBagDetailsTable = false
        this.IsOverageShipmentBagTable = true
      }
    },
    openModal(bdata) {
      this.modaldata = bdata
      this.modalShow = true
      this.getBagShortageReason()
    },
    closeModal() {
      this.modalShow = false
      this.reasonitem = {
        value: '',
        text: ''
      }
      this.reason = ''
      this.Isreasonerror = ''
      this.reasonError = ''
    },
    //get selected shortage reason
    selectReason(reasonitem) {
      this.reasonitem = reasonitem
      this.reason = this.reasonitem.text
      if (this.reasonitem.text == '') {
        this.Isreasonerror = '1',
          this.reasonError = 'The Shortage Reason field is required.'
      } else {
        this.Isreasonerror = '',
          this.reasonError = ''
      }
    },
    ConfirmbBagShortageMark(data) {
			this.ConfirmBagShortage = true;
      this.ShortageBagNo = data.bagno;
		},
		CloseConfirmation() {
			this.ConfirmBagShortage = false;
		},
    //called on mark bag shoratge button in modal
    markBagShortage(type) {
      if (this.Prealertmodal == true && this.selectedRow == '') {
        this.selectedRowError = 'Select Bag Number'
        return false;
      } else {
        this.selectedRowError = ''
      }
      // if (this.reasonitem.text == '') {
      //   this.Isreasonerror = '1',
      //     this.reasonError = 'The Shortage Reason field is required.'
      //   return false;
      // } else {
      //   this.Isreasonerror = '',
      //     this.reasonError = ''
      // }
      this.isLoadingSearch = true;
      if (type == 'Shortage') {
        this.input = ({
          "currentHubId": this.hubid,
          "currentHubName": this.hubName,
          "parentBagNo": this.ShortageBagNo,
          "lastModifiedBy": this.createdby,
          "reason": this.reasonitem.text,
          "statusMarkedFrom": "WEB"
        })
      } else {
        this.input = ({
          "currentHubId": this.hubid,
          "currentHubName": this.hubName,
          "parentBagNo": this.modaldata.bagnumber,
          "lastModifiedBy": this.createdby,
          "reason": this.reasonitem.text,
          "statusMarkedFrom": "WEB"
        })
      }
      if (this.Prealertmodal == true && this.selectedRow.bagno != '') {
        this.input.parentBagNo = this.selectedRow.bagno
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'markBagShortage',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.$alertify.success(result.data.ReturnMessage)
            this.modalShow = false
            this.isLoadingSearch = false;
            this.ConfirmBagShortage = false;
            this.reason = ''
            this.reasonitem = {
              value: '',
              text: ''
            }
            this.BagShortageData = []
            this.getPendingInscanBagCount();
            this.getPendingInscanBagList();
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.isLoadingSearch = false;
            this.ConfirmBagShortage = false;
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.isLoadingSearch = false;
            this.ConfirmBagShortage = false;
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoadingSearch = false;
          console.error(error)
        })
    },
    //to get Shortage reason
    getBagShortageReason() {
      this.reasonlist = []
      this.input = ({})
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "getBagShortageReasonMaster",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            var BagShoratgeReasonData = result.data.ResponseData
            for (var i = 0; i < BagShoratgeReasonData.length; i++) {
              this.reasonlist.push({
                value: BagShoratgeReasonData[i].bagshortagereasonmasterid,
                text: BagShoratgeReasonData[i].bagshortagereason
              })
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    //reset search filter's field
    resetflt() {
      this.connectiontype = ''
      this.connectionname = ''
      this.connectionfltlist = []
      this.ConnectionNameData = []
      this.BagShortageData = []
      this.BagDetails = []
      this.BagData = []
      this.opened = []
      this.connectionfltitem = {
        value: '',
        text: '',
        destinationhubid: ''
      }
      this.bagno = ''
      this.isConnectionError = 0
      this.ConnectionError = ''
      this.IsBagDetailsTable = false
      this.IsOverageShipmentBagTable = true
      this.$validator.reset()
    },
    //used in filter form
    onSubmitflt: function(flt) {
      this.$validator.validateAll('flt').then((result) => {
        if (!result) {
          return false;
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    //for missing paper bag
    openMissingPaperBagModal() {
      this.IsMissingPaperBag = true
      this.getPaperBagListForMarkMissing();
    },
    closeMissingPaperBagModal() {
      this.IsMissingPaperBag = false
    },
    getPaperBagListForMarkMissing(type) {
      this.missingpaperbaglist = []
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + "getPaperBagsDetailsByCSMID?hubId=" + this.hubid + "&connectionScheduleMasterId=" + this.ScheduleID,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            var paperBagList = result.data.ResponseData
            for (var i = 0; i < paperBagList.length; i++) {
              this.missingpaperbaglist.push({
                text: paperBagList[i].paperbagno
              })
            }
          } else if (result.data.ResultCode == 101) {
            if (type !== 'MarkedMissing') {
              this.$alertify.error(result.data.ReturnMessage)
            }
            this.disablePaperWorkBtn = true
            this.disablescanInBtn = false
            this.disableField = false
          } else {
            this.missingpaperbaglist = []
            if (type !== 'MarkedMissing') {
              this.$alertify.error(result.data.ReturnMessage)
            }
          }
        }, error => {
          console.error(error)
        })
    },
    checkMissingPaperBag() {
      if (this.missingpaperbag == '') {
        this.MissingPaperBagError = "The Paper Bag field is required."
      } else {
        this.MissingPaperBagError = ''
      }
    },
    checkMissingReason() {
      if (this.missingreason == '') {
        this.MissingReasonError = "The Reason field is required."
      } else {
        this.MissingReasonError = ''
      }
    },
    markPaperBagMissing() {
      if (this.missingpaperbag == '') {
        this.MissingPaperBagError = "The Paper Bag field is required."
        return false;
      } else if (this.missingreason == '') {
        this.MissingReasonError = "The Reason field is required."
        return false;
      } else {
        this.MissingPaperBagError = ''
        this.MissingReasonError = ''
        this.input = ({
          "PaperBag": this.missingpaperbag,
          "CurrentHubId": this.hubid,
          "CurrentHubName": this.hubName,
          "Reason": this.missingreason,
          "CreatedBy": this.createdby,
          "MissingType": this.missingreason == "Missing" ? true : false,
          "connectionScheduleMasterId": this.ScheduleID,
          "isManualEntry": this.manualInput
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + "markPaperBagMissing",
            'data': this.input,
            'headers': {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.$alertify.success(result.data.ReturnMessage)
              this.missingpaperbag = ''
              this.missingpaperbagitem = {
                text: ''
              }
              this.MissingPaperBagError = ''
              this.missingreason = ''
              this.MissingReasonError = ''
              this.manualInput = false
              this.getPaperBagListForMarkMissing('MarkedMissing')
            } else {
              this.$alertify.error(result.data.ReturnMessage)
            }
            this.paperWorkComplete = result.data.paperWorkComplete
            this.pendingCount = result.data.pendingCount
            if (this.paperWorkComplete == true) {
              this.disablescanInBtn = false
              this.disablePaperWorkBtn = true
              this.disableField = false
            } else {
              this.disablescanInBtn = true
              this.disablePaperWorkBtn = false
              this.disableField = true
            }
          }, error => {
            console.error(error)
          })
      }
    },
    selectedMissingPaperBag(missingpaperbagitem) {
      this.missingpaperbagitem = missingpaperbagitem
      this.missingpaperbag = missingpaperbagitem.text
    },
    MarkMisRouteBag() {
      this.isexceptional = true
    },
    resetMissingPaperBagField() {
      this.missingpaperbag = ''
      this.missingpaperbaglist = []
      this.missingpaperbagitem = {
        text: ''
      }
      this.MissingPaperBagError = ''
      this.missingreason = ''
      this.MissingReasonError = ''
      // this.missroutemsg = ''
      this.IsMissingPaperBag = false
    },


    //for paper Work
    getPendingWorkBagList() {
      if (this.routetype == 'network-local') {
        var routetype = 4
      } else {
        var routetype = 0
      }
      this.showPendingList = true
      window.scrollTo(0, 1000);
      this.parentBagDetails = []
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "getPendingPaperNoByHubId?hubid=" + this.hubid + "&connectionType=" + routetype,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.parentBagDetails = result.data.ResponseData
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    getPendingMPSList(data, ind) {
      this.childBagDetails = true
      const index = this.viewdata.indexOf(ind);
      if (index > -1) {
        this.viewdata.splice(index, 1)
      } else {
        this.viewdata = [];
        this.viewdata.push(ind)
      }
      this.input = ({
        "paperNo": data.paperno
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "getParentMPSDetailsByPaperNo",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.childBagDetails = result.data.ResponseData.ShipmentDetails
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    closePendingMPSList() {
      this.viewdata = [];
    },
    closePendingWorkBagList() {
      this.showPendingList = false
    },

    getPendingPaperBagCount() {
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getPendingPaperBagCountForInScan?connectionScheduleMasterId=' + this.ScheduleID + '&hubId=' + this.hubid,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.PendingPaperBagsCount = result.data.PendingPaperBagsCount
          } else if (result.data.ResultCode == 101) {
            this.PendingPaperBagsCount = result.data.PendingPaperBagsCount
          } else {
            this.PendingPaperBagsCount = ''
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },

    getGeneratedPaperBagNoDetails() {
      if (this.paperbagno == '') {
        this.PaperBagNoError = 'The Bag No field is required.'
        return false;
      } else {
        this.PaperBagNoError = ''
        this.generatedPaperBagDetails = []
        this.input = ({
          "paperBagNo": this.paperbagno.trim()
        })
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'getPaperWorkDetailsByPaperBagNoForscanIn', //'getPaperWorkDetailsByPaperBagNo',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.generatedPaperBagDetails = result.data.ResponseData
              this.isExistBag = true
              this.IsParentAWB = true
              this.$alertify.success(result.data.ReturnMessage)
              this.getPendingPaperBagCount()
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.isExistBag = false
              this.IsParentAWB = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      }
    },
    openPaperWorkBagCard() {
      this.IsPaperWorkBag = true
      this.getPendingPaperBagCount()
    },
    closePaperWorkBagCard() {
      this.IsPaperWorkBag = false
      this.resetBag()
      this.resetMissingPaperBagField()
    },
    scanPaperWorkBag(IsAWB) {
      if (this.paperbagno == '') {
        this.PaperBagNoError = 'The Bag No field is required.'
        return false;
      } else {
        this.PaperBagNoError = ''
      }
      if (IsAWB == 1 && this.parentAWB == '') {
        this.ParentAWBError = 'The Parent AWB field is required.'
        return false;
      } else {
        this.ParentAWBError = ''
      }
      if (this.isexceptional == true && this.exceptionreason == '') {
        this.ExceptionError = 'Select Exception Reason'
        return false;
      } else {
        this.ExceptionError = ''
      }
      // if (IsAWB == 1) {
      var str = this.parentAWB.toLowerCase()
      if (str.startsWith("pls")) {
        this.paperbagno = str
        this.isExistBag = true
      }
      // }
      if (this.parentAWB != "") {
        var AWBNo = this.parentAWB
      } else {
        var AWBNo = this.paperbagno
      }

      this.input = ({
        "paperBag": this.paperbagno,
        "paperBagNo": AWBNo,
        //"paperBagNo": this.paperbagno,
        "hubId": this.hubid,
        "currentHubName": this.hubName,
        "lastModifiedBy": this.createdby,
        "isException": this.isexceptional,
        "expReason": this.exceptionreason,
        "connectionScheduleMasterId": this.vehicletypeitem.value,
        "missingType": this.missingType,
        "isManualEntry":this.manualInscan
      })
      if (this.routetype == "network-local") {
        this.input.connectionScheduleMasterId = this.networklocalvehicleitem.value
      }
      if (IsAWB == 1) {
        this.input.paperBagNo = this.parentAWB
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'paperLessWorkScanIn',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.missroutemsg = ''
            this.missingType = false
            this.isexceptional = false
            this.IsParentAWB = true
            this.paperbagno !== '' ? this.isExistBag = true : this.isExistBag = false
            this.$alertify.success(result.data.ReturnMessage)
            if (IsAWB == 1) {
              this.parentAWB = ''
              this.ParentAWBError = ''
            }
            this.manualInscan=false
          } else if (result.data.ResultCode == 401) {
            this.missroutemsg = ''
            this.missingType = false
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 105) {
            this.missroutemsg = result.data.ReturnMessage
            this.isexceptional = true
            this.missingType = true
          } else {
            this.missroutemsg = ''
            this.isexceptional = false
            this.invalidTokenModal = false
            this.missingType = false
            this.$alertify.error(result.data.ReturnMessage)
            if (IsAWB == 1) {
              this.IsParentAWB = true
              this.isExistBag = true
            } else {
              this.IsParentAWB = false
              this.isExistBag = false
            }
          }
          this.paperWorkComplete = result.data.paperWorkComplete
          this.pendingCount = result.data.pendingCount
          if (this.paperWorkComplete == true) {
            this.disablescanInBtn = false
            this.disablePaperWorkBtn = true
            this.disableField = false
          } else {
            this.disablescanInBtn = true
            this.disablePaperWorkBtn = false
            this.disableField = true
          }
        }, error => {
          console.error(error)
        })
    },
    resetBag() {
      this.paperbagno = ''
      this.parentAWB = ''
      this.PaperBagNoError = ''
      this.isexceptional = false
      this.exceptionreason = ''
      this.ExceptionError = ''
      this.ParentAWBError = ''
      this.PendingPaperBagsCount = ''
      this.missroutemsg = ''
      this.generatedPaperBagDetails = []
      this.missingType = false
      this.IsParentAWB = false
      this.isExistBag = false
      this.manualInscan = false
      this.ShortageBagNo = ''
    },
    checkPaperBagNo() {
      if (this.paperbagno == '') {
        this.PaperBagNoError = 'The Bag No field is required.'
      } else {
        this.PaperBagNoError = ''
      }
    },
    checkParentAWB() {
      if (this.parentAWB == '') {
        this.ParentAWBError = 'The Parent AWB field is required.'
      } else {
        this.ParentAWBError = ''
      }
    },
    getPendingInscanBagCount() {
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getInScanPendingCount?ConnectionScheduleMasterId=' + this.ScheduleID + '&CurrentHubId=' + this.hubid,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.InScannedBagsCount = result.data.InScannedBagsCount;
            this.PendingBagsCount = result.data.InscanPendingBagsCount;
            this.ShortageBagsCount = result.data.ShortageBagsCount
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
          }
        }, error => {
          console.error(error);
        })
    },
    openPendingInscanList(IsButtonType, type) {
      window.scrollTo(0, 500);
      this.IsPendingInscanList = true
      if (IsButtonType == 'Pending') {
        this.bagstatus = 'Pending'
        this.PendingInscanBagData = [];
        this.isShoratge = false
      } else if (IsButtonType == 'InScanned') {
        this.bagstatus = 'InScanned'
        this.PendingInscanBagData = [];
        this.isShoratge = false
      } else {
        this.isShoratge = false
        this.bagstatus = ''
      }
      if (IsButtonType == 'Pending' && type == 'MarkShortage') {
        this.bagstatus = 'Pending'
        this.listtype = 'Ecom'
        this.isShoratge = true
        this.IsPendingInscanList = false
      }
      if (this.listtype != '') {
        this.getPendingInscanBagCount();
        this.getPendingInscanBagList();
      }
    },
    getPendingInscanBagList() {
      this.input = {
        "ConnectionScheduleMasterId": this.ScheduleID,
        "CurrentHubId": this.hubid,
        "Status": this.bagstatus,
        "ListType": this.listtype
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getInScanAndPendingList',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.PendingInscanBagData = result.data.ResponseData;
            this.getPendingInscanBagCount();
            this.$alertify.success(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.PendingInscanBagData = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error);
        })
    },

    displayShortageBagList() {
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getShortageBagsList?ConnectionScheduleMasterId=' + this.ScheduleID + "&CurrentHubId=" + this.hubid,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.ShortageBagRecord = result.data.ResponseData;
            this.$alertify.success(result.data.ReturnMessage)
          } else {
            this.ShortageBagRecord = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error);
        })
    },

    //For Close Vehicle
    hideCloseVehicleModal() {
      this.closeVehicleModal = false
      this.IsAllowToCloseVehicle = false
      this.CloseVehicleMsg = ''
    },
    closeVehicle(type) {
      if (type == 'Yes') {
        this.IsAllowToCloseVehicle = true
      } else {
        this.IsAllowToCloseVehicle = false
      }
      if (type == 'loadbag') {
        if (this.routetype == 'network') {
          this.input = ({
            "ConnectionScheduleMasterID": this.ScheduleID,
            "IsClose": false,
            "CurrentHubId": this.hubid,
            "VehicleSealNo": this.vehiclesealno,
            "LastModifiedBy": this.createdby,
            "IsConfirm": false
          })
        } else {
          this.input = ({
            "ConnectionScheduleMasterID": this.ScheduleID,
            "IsClose": false,
            "CurrentHubId": this.hubid,
            "VehicleSealNo": this.vehiclesealno,
            "LastModifiedBy": this.createdby,
            "IsConfirm": false
          })
        }
      } else {
        if (this.routetype == 'network') {
          this.input = ({
            "ConnectionScheduleMasterID": this.ScheduleID,
            "IsClose": true,
            "CurrentHubId": this.hubid,
            "VehicleSealNo": this.vehiclesealno,
            "LastModifiedBy": this.createdby,
            "IsConfirm": this.IsAllowToCloseVehicle
          })
        } else {
          this.input = ({
            "ConnectionScheduleMasterID": this.ScheduleID,
            "IsClose": true,
            "CurrentHubId": this.hubid,
            "VehicleSealNo": this.vehiclesealno,
            "LastModifiedBy": this.createdby,
            "IsConfirm": this.IsAllowToCloseVehicle
          })
        }
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'closeVehicle',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.closeVehicleModal = false
            this.$alertify.success(result.data.ReturnMessage)
            this.resetForm();
          } else if (result.data.ResultCode == 105) {
            this.closeVehicleModal = false
            this.$alertify.success(result.data.ReturnMessage)
            if (type == 'loadbag') {
              this.$router.push('/NetworkManagement')
            }
          } else if (result.data.ResultCode == 109) {
            this.CloseVehicleMsg = result.data.ReturnMessage
            this.closeVehicleModal = true
          } else {
            this.closeVehicleModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error);
        })
    },


    getCargoParentMPSDetails(data) {
      this.CargoParentMPSDetails = [];
      this.CargoParentMPSDataModel = true
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getCargoParentMPSDetails?ParentMPS=' + data.ParentMPS + '&ShipmentStatus=' + data.Status,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.CargoParentMPSDetails = result.data.ResponseData;
          } else {
            this.CargoParentMPSDetails = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error);
        })
    },
    closeCargoParentMPSDataModel() {
      this.CargoParentMPSDataModel = false
    },
    //for prealert data
    openPrealertmodal() {
      this.Prealertmodal = true
    },
    closePrealertmodal() {
      this.Prealertmodal = false
      this.resetModalField()
    },
    resetModalField() {
      this.selectedRow = ''
      this.reasonitem = {
        value: '',
        text: ''
      }
      this.reason = ''
      this.Isreasonerror = ''
      this.reasonError = ''
      this.selectedRowError = ''
    },
    getPrealertTripData(IsReloadList) {
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getDestinationPrealert?hubid=' + this.hubid,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.PrealertTripData = result.data.ResponseData;
            if (IsReloadList == 1) {
              this.$alertify.success(result.data.ReturnMessage)
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.PrealertTripData = [];
            if (IsReloadList == 1) {
              this.$alertify.error(result.data.ReturnMessage)
            }
          }
        }, error => {
          console.error(error);
        })
    },
    getPrealertBagData(data, ind) {
      this.PrealertPrintmodal = true
      this.PrintData = data
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'generateBagDetailInvoice?connectionschedulemasterid=' + data.connectionschedulemasterid,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.PrealertBagData = result.data.ResponseData;
            this.prealertConnection = result.data.ResponseData[0].connectionname
            this.prealertVehicle = result.data.ResponseData[0].vehicleno
            this.prealertInvoiceDate = result.data.ResponseData[0].invoicedate
            this.prealertInvoiceTime = result.data.ResponseData[0].invoicetime
            var shipment = []
            var phywt = []
            var volwt = []
            for (var i = 0; i < this.PrealertBagData.length; i++) {
              shipment.push(Number(this.PrealertBagData[i].bagshipmentscnt))
              phywt.push(Number(this.PrealertBagData[i].physicalweight))
              volwt.push(Number(this.PrealertBagData[i].volumetricweight))
            }
            this.totalshipment = shipment.reduce(function(acc, val) {
              return acc + val;
            }, 0)
            this.totalphysicalwt = phywt.reduce(function(acc, val) {
              return acc + val;
            }, 0)
            this.totalvolumetricwt = volwt.reduce(function(acc, val) {
              return acc + val;
            }, 0)
            this.$alertify.success(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.PrealertBagData = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error);
        })
    },
    closePrealertPrintmodal() {
      this.PrealertPrintmodal = false
    },
    getPrealertBagShortageData(data, index) {
      this.Prealertmodal = true
      this.PrealertBagShortageList = []
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getBagDetailsForPrealert?connectionschedulemasterid=' + data.connectionschedulemasterid + '&destinationhubid=' + this.hubid,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.PrealertBagShortageList = result.data.ResponseData;
            this.getBagShortageReason()
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.PrealertBagShortageList = [];
          }
        }, error => {
          console.error(error);
        })
    },
    selectBag() {
      if (this.selectedRow == '') {
        this.selectedRowError = 'Select Bag Number'
      } else {
        this.selectedRowError = ''
      }
    },
    download() {
      const doc = new jsPDF('p', 'pt', 'a2');
      const contentHtml = document.getElementById('printData');
      doc.fromHTML(contentHtml, 15, 15, {
        width: 170,
      });
      doc.save("prealert.pdf");
    },
    //Print Unloading Sheet
    openUnloadingSheetModel() {
      this.UnloadingSheetModel = true
      this.IsUnloadingSheet = true
    },
    closeUnloadingSheetModel() {
      this.UnloadingSheetModel = false
      this.unloadingtripsheetno = ''
      this.TripSheetNoError = ''
      this.IsSheet = false
      this.isLoadingSheetModal = false
    },
    cancelUnloadingSheetField() {
      this.unloadingtripsheetno = ''
      this.TripSheetNoError = ''
      this.UnloadingTripData = []
      this.UnloadingBagData = []
      this.IsSheet = false
      this.isLoadingSheetModal = false
    },
    getUnloadingTripSheetDetails() {
      if (this.unloadingtripsheetno == '') {
        this.TripSheetNoError = 'The Trip Sheet No field is required.'
        return false;
      } else {
        this.TripSheetNoError = ''
        this.UnloadingTripData = []
        this.UnloadingBagData = []
        this.isLoadingSheetModal = true
        axios({
            'method': 'GET',
            'url': apiUrl.api_url_hubops + 'getPaperBagsWithAWBDetailsByTripNo?tripSheetNo=' + this.unloadingtripsheetno.trim() + '&currentHubId=' + this.hubid,
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then(result => {
            this.isLoadingSheetModal = false
            if (result.data.ResultCode == 100) {
              this.UnloadingTripData = result.data.TripDetails;
              this.UnloadingBagData = result.data.BagDetails;
              this.IsSheet = true
              this.$alertify.success(result.data.ReturnMessage)
            } else {
              this.UnloadingTripData = [];
              this.UnloadingBagData = [];
              this.IsSheet = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.isLoadingSheetModal = false
            console.error(error);
          })
      }
    },
    getBag(string) {
      let reg = /.{1,6}/
      return string.replace(reg, (m) => "*".repeat(m.length))
    },
    gettotalMPSCount(row) {
      var totalMPSCount = 0;
      for (var i = 0; i < row.length; i++) {
        totalMPSCount = totalMPSCount + parseFloat(row[i].mpscount)
      }
      return totalMPSCount;
    },
    gettotalWeight(row) {
      var totalWeight = 0;
      for (var i = 0; i < row.length; i++) {
        totalWeight = totalWeight + parseFloat(row[i].parentawbweight)
      }
      return totalWeight;
    },
    printSheet() {
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          `
      d.print(document.getElementById('tripsheetContent'), cssText);
    },

    /*nxb and xb changes*/
    validatebuttons(){
      let result = false
      if(this.updatedVehicleSealNo && this.vehiclesealdata && this.vehiclesealdata.sealprefix){
        for (let i = 0; i < this.vehiclesealdata.sealprefix.length; i++) {
          if (this.updatedVehicleSealNo.toLowerCase().startsWith(this.vehiclesealdata.sealprefix[i].toLowerCase())) {
            result = true;
            break;
          }
        }
      }
      return result;
    },

    validateforDepartureSealNo(){
    let result = false
    if(this.networklocaldeparturesealno && this.vehiclesealdata && this.vehiclesealdata.sealprefix){
      for (let i = 0; i < this.vehiclesealdata.sealprefix.length; i++) {
        if (this.networklocaldeparturesealno.toLowerCase().startsWith(this.vehiclesealdata.sealprefix[i].toLowerCase())) {
            result = true;
            break;
          }
        }
    }
    return result;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/CenterScanInTrip_v1/CenterScanInTrip_v1.js